<template>
  <div class="preview-block">
    <div class="preview-block__head">
      <q-icon :name="icon" size="14px" class="q-mr-xs" />
      <span>{{ title }}</span>
      <q-badge v-if="items.total" color="grey-6" :label="items.total" class="q-ml-xs" />
    </div>

    <div v-if="!items.total" class="preview-block__empty">
      {{ emptyText }}
    </div>

    <template v-else>
      <div
        v-for="(row, idx) in items.rows"
        :key="idx"
        class="preview-block__row"
      >
        <div class="preview-block__label">{{ row[labelKey] || "—" }}</div>
        <div v-if="row[subKey]" class="preview-block__sub">{{ row[subKey] }}</div>
      </div>
      <div v-if="items.rest" class="preview-block__more">
        и ещё {{ items.rest }}...
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "add-grade-step-preview-block",
  props: {
    title: { type: String, required: true },
    icon: { type: String, default: "info" },
    items: { type: Object, default: () => ({ rows: [], total: 0, rest: 0 }) },
    emptyText: { type: String, default: "Нет данных" },
    labelKey: { type: String, default: "label" },
    subKey: { type: String, default: "comment" },
  },
};
</script>

<style scoped lang="scss">
.preview-block {
  & + & {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dashed #e2e8f0;
  }

  &__head {
    display: flex;
    align-items: center;
    font-size: 11px;
    font-weight: 600;
    color: #475569;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    margin-bottom: 6px;
  }

  &__empty {
    font-size: 11px;
    color: #94a3b8;
  }

  &__row {
    padding: 4px 0;

    & + & {
      border-top: 1px solid #f1f5f9;
    }
  }

  &__label {
    font-size: 12px;
    color: #334155;
    line-height: 1.3;
  }

  &__sub {
    font-size: 10px;
    color: #94a3b8;
    line-height: 1.3;
    margin-top: 1px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__more {
    font-size: 10px;
    color: #64748b;
    margin-top: 4px;
  }
}
</style>
